import { get_axios_instance, api_variables } from '@/apis/variables.js';

var axios_instance = get_axios_instance(api_variables.SERVICE_SMTP);

const _pk_name = "id";

const state = {
  data: {},
  isFetching: false,
  isSaving: false,
  isDeleting: false,
};

const mutations = {
  set: (state, payload) => {
    state.data = payload;
  },

  add: (state, payload) => {
    state.data.push(payload);
  },

  updateById: (state, payload) => {
    for(let i=0; i<state.data.length; i++) {
      if(state.data[i][_pk_name] === payload.id) {
        state.data.splice(i, 1, payload);
      }
    }
  },

  removeById: (state, payload) => {
    for (let i=0; i<state.data.length; i++){
      if (state.data[i][_pk_name] == payload){
        state.data.splice(i, 1);
      }
    }
  },

  setFetching: (state, payload) => {
    state.isFetching = payload;
  },

  setSaving: (state, payload) => {
    state.isSaving = payload;
  },

  setDeleting: (state, payload) => {
    state.isDeleting = payload;
  }
}

const actions = {
  async fetchAll({commit}, payload) {
      //console.log("[state/dashboard/organisation/utilities/smtp/fetchAll] Calling API...");
    try {
      commit("setFetching", true);
      let res = await axios_instance.get(`/`, {
        params: {
          org_id: payload
        }
      });
      commit("setFetching", false);
      //console.log("[state/dashboard/organisation/utilities/smtp/fetchAll] res: ", res);
      if(res.status == 200) {
        //console.log('rows data', res.data.rows)
        commit("set", res.data.rows);
      }

      return res;
    }catch {

    }
  },

  async create({commit}, payload) {
      //console.log("[state/dashboard/organisation/utilities/smtp/create] Adding...", payload);
    try {
      commit("setSaving", true);
      let res = await axios_instance.post(`/`, payload );
      commit("setSaving", false);
      //console.log("[state/dashboard/organisation/utilities/smtp/create] res: ", res);
      if(res.status == 200) {
        commit("addEntity", res.data);
      }
      return res;
    }catch {

    }
  },

  async update({commit}, payload) {
      //console.log("[state/dashboard/organisation/utilities/smtp/update] Updating... Display payload", payload);
    try {
      commit("setSaving", true);
      let res = await axios_instance.put(`/`, payload);
      commit("setSaving", false);
      //console.log("[state/dashboard/organisation/utilities/smtp/update] res: ", res);
      if(res.status == 200) {
        commit("updateEntityById", res.data);
      }
      return res;
    }catch {

    }
  },

  async delete({commit}, payload) {
    //console.log("[state/dashboard/organisation/utilities/smtp/delete] Payload:", payload);
    //console.log("[state/dashboard/organisation/utilities/smtp/delete] Payload:", `/${payload.id}`);
    try {
      commit("setDeleting", true);
      let res = await axios_instance.delete(`/${payload.id}`);
      commit("setDeleting", false);
      if (res.status == 200){
        commit("removeEntityById", payload.id);
      }
    }catch {

    }
  }
}

export default {
  namespaced: true,
  state, mutations, actions
}
